<div class="mobile-nav-backdrop" [class.visible]="isOpen"
  (click)="close()"
  (touchend)="close()">
</div>

<aside class="mobile-nav-drawer" [class.open]="isOpen"
  (click)="$event.stopPropagation()"
  (touchend)="$event.stopPropagation()">

  <div class="nav-header">
    <div class="brand">
      <img src="assets/AivorLogo.png" alt="Aivor" class="brand-logo" />
      <span class="brand-text">AIVOR</span>
    </div>

    <button type="button" class="close-btn"
      (click)="close()"
      (touchend)="closeTouchEnd($event)"
      aria-label="Close navigation">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="nav-links">
    <a
      *ngFor="let link of links"
      class="nav-link"
      [routerLink]="link.routerLink"
      routerLinkActive="active"
      (click)="onNavigate()"
      (touchend)="onNavigateTouch(link, $event)"
    >
      <i class="bi" [ngClass]="link.iconClass"></i>
      <span>{{ link.label }}</span>
    </a>
  </div>
</aside>
